import BaseError from './base-error'

export default class NotImplementedError extends BaseError {
  public constructor(methodName: string) {
    super(`${methodName} is not implemented`, 'not_implemented_error')
  }
}
